module.exports = __webpack_public_path__ + "media/images/pages/home_featured/who-we-are-invitation-b3717209f65522e9a4541864a343becd.png";